import { render, staticRenderFns } from "./UploadTalonFuelPrices.vue?vue&type=template&id=c3afbbc2&"
import script from "./UploadTalonFuelPrices.vue?vue&type=script&lang=js&"
export * from "./UploadTalonFuelPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports